import type { AppProps } from 'next/app';
import 'core-js/features/string/replace-all';
import '../styles/banner.css';
import '../styles/index.css';
import '../styles/post-body.css';
import '../styles/traditional/banner.css';
import '../styles/traditional/style.css';

function MyApp({ Component, pageProps }: AppProps) {
  return <Component {...pageProps} />;
}

export default MyApp;
